import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAccountContext from '../../authentication/hooks';

const DisplayUserAndOrgName = () => {
    const account = useAccountContext();
    return (
        <>
            <span className='d-block user-name fw-bold text-break'>
                <span className='visually-hidden'>{'User signed in as: '}</span>
                {account?.details?.givenName}
                {' '}
                {account?.details?.familyName}
                <span className='visually-hidden'>,</span>
            </span>
            <span className='d-block org-name text-break'>
                {account?.details?.organisation}
            </span>
            <span className='d-block org-name text-break'>
                {!!(account?.details?.trading) && (`${account?.details?.trading}`)}
                {!!(account?.details?.branch) && (` - ${account?.details?.branch}`)}
            </span>
        </>
    );
};

const AuthenticatedNavbarItems = () => {
    const account = useAccountContext();

    if (!account?.details?.email) {
        return null;
    }

    const onShowBranchSelectorClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => { account.setShowBranchSelector(true); };

    return (
        <Dropdown
            align='end'
            id='user-menu-dropdown'
            data-testid='user-menu-dropdown'
        >
            <Dropdown.Toggle
                id='user-menu'
                variant='dark'
            >
                <h2 className='visually-hidden text-white'>Current user navigation</h2>
                <div className='d-none d-md-block text-end me-2'>
                    <DisplayUserAndOrgName />
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu variant='dark'>
                <Dropdown.ItemText className='d-block d-md-none'>
                    <DisplayUserAndOrgName />
                </Dropdown.ItemText>
                <Dropdown.Item
                    as={Link}
                    to={`/update-organisation/${account.details.defaultOrganisationId}`}
                >
                    Manage organisation
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    to='/update-contact'
                >
                    Manage contact information
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    onClick={onShowBranchSelectorClick}
                    to='/dashboard#0'
                >
                    Add or manage branch/location
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    to='/sign-out'
                >
                    Log out
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default AuthenticatedNavbarItems;
